<template>
  <div class="password-reset">
    <div class="container mt-5">
      <h1>Password Reset</h1>
      <form class="my-3" novalidate @submit="checkForm" autocomplete="off">
        <div class="form-group pt-3">
          <input
            type="password"
            class="form-control"
            id="Password"
            placeholder="New Password"
            v-model="reset.Password"
            autocomplete="new-password"
          />
        </div>
        <div class="form-group pt-3">
          <input
            type="password"
            class="form-control"
            id="ConfirmPassword"
            placeholder="Confirm Password"
            v-model="reset.ConfirmPassword"
            autocomplete="new-password"
          />
        </div>

        <div v-if="formErrors.length">
          <div
            class="alert alert-danger alert-dismissible fade show"
            role="alert"
            v-for="error in formErrors"
            :key="error"
          >
            {{ error }}
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div v-if="passwordResetErrors.length">
          <div
            class="alert alert-danger alert-dismissible fade show"
            role="alert"
            v-for="error in passwordResetErrors"
            :key="error"
          >
            {{ error }}
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div
          v-if="passwordResetSuccess"
          class="alert alert-success alert-dismissible fade show"
          role="alert"
        >
          Password reset successully!
          <router-link :to="{ name: 'home' }">Log In</router-link>
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <button v-if="loading" class="btn btn-primay btn-block mt-3" disabled>
          Loading...
        </button>
        <button v-else type="submit" class="btn btn-primary btn-block mt-3">
          Reset Password
        </button>
      </form>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/Footer.vue";

export default {
  name: "PasswordReset",
  components: {
    Footer
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    passwordResetErrors() {
      return this.$store.getters.passwordResetErrors;
    },
    passwordResetSuccess() {
      return this.$store.getters.passwordResetSuccess;
    }
  },
  data() {
    return {
      reset: {
        Password: "",
        ConfirmPassword: ""
      },
      formErrors: []
    };
  },
  methods: {
    checkForm(e) {
      e.preventDefault();
      this.formErrors = [];

      let missingInputs = 0;
      for (let formInput of e.target.elements) {
        const value = formInput.value.trim();

        if (formInput.nodeName === "INPUT") {
          if (value) {
            formInput.classList.remove("is-invalid");
            formInput.classList.add("is-valid");
          } else {
            formInput.classList.remove("is-valid");
            formInput.classList.add("is-invalid");
            missingInputs++;
          }
        }
      }

      if (missingInputs > 0) {
        this.formErrors.push("Please provide a new password");
      } else {
        //Password checks
        if (this.reset.Password !== this.reset.ConfirmPassword) {
          let passwordInput = document.getElementById("Password");
          let confirmPasswordInput = document.getElementById("ConfirmPassword");

          this.formErrors.push("Passwords don't match!");

          passwordInput.classList.remove("is-valid");
          passwordInput.classList.add("is-invalid");

          confirmPasswordInput.classList.remove("is-valid");
          confirmPasswordInput.classList.add("is-invalid");
        }
      }

      if (this.formErrors.length === 0) {
        let dataToSend = {
          UserId: this.$route.params.id,
          Token: this.$route.params.token,
          Password: this.reset.Password,
          ConfirmPassword: this.reset.ConfirmPassword
        };

        this.$store.dispatch("resetPassword", dataToSend);
      }
    }
  }
};
</script>
